globalThis.dataLayer = globalThis.dataLayer || []

export default function gtag () { globalThis.dataLayer.push(arguments) }
